// extracted by mini-css-extract-plugin
module.exports = {"add":"AddWorkspace_add__1nlTz"};